import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { model as router } from '~/core/router'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout } from '~/widgets/auth'
import { FinalMessage } from '../../shared/ui'
import { $failFormTranslations } from '../translations'

export function Title(): JSX.Element {
  return <AppTitle t='fail' />
}

ErrorPage.displayName = 'ErrorPage'
export function ErrorPage(): JSX.Element {
  const formTranslations = useUnit($failFormTranslations)
  const state = useUnit(router.$state)
  const textError =
    typeof state === 'string' ? state : formTranslations.unknownErr

  return (
    <AuthLayout>
      <FinalMessage
        title={formTranslations.title}
        body={textError}
        button={formTranslations.textButton}
        to='/sign-in'
      />
    </AuthLayout>
  )
}
